






































import Vue, { VueConstructor } from 'vue'
import { mapState } from 'vuex'
import { VariantType } from '@/application/models/chords';
import { KeyScaleChord, KeyScaleDegree } from "@/application/models/ScaleInKey";
import { suggestNextChord } from '@/application/ChordSuggester'
import { PreciseChordWeighting } from '@/application/models/chordWeightings';
import { SetChordParameters } from '@/application/models/chordProgression';
import { setChord } from '@/application/ChordProgressionManager'
import ChordOption from '@/components/ChordOption.vue'
import IconOrderHorizontal from '@/assets/icons/icon-order-horizontal.svg'
import hasBreakpoints, { HasBreakpointsMixinComputed } from '@/mixins/hasBreakpoints'
import hasChordProgression, { HasChordProgressionMixinData } from '@/mixins/hasChordProgression'
import hasScaleInKey, { HasScaleInKeyMixinData } from '@/mixins/hasScaleInKey'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'

interface ChordOptionVm {
  getChordParameters(): SetChordParameters
}

type Mixins = HasChordProgressionMixinData & HasBreakpointsMixinComputed & HasScaleInKeyMixinData & HasEnharmonicsMixinData

export default (Vue as VueConstructor<Mixins>).extend({
  name: 'ChordSelector',
  mixins: [hasBreakpoints, hasChordProgression, hasScaleInKey, hasEnharmonics],
  components: {
    ChordOption,
    IconOrderHorizontal
  },
  data() {
    const orders = [
      { name: 'degree' },
      { name: 'function' }
    ]
    return {
      orders,
      order: orders[0],
      showSuggestions: false
    }
  },
  computed: {
    ...mapState('sampler', [
      'samplerLoaded',
      'sampler'
    ]),
    ...mapState('chordProgression', [
      'selectedIndex'
    ]),
    orderedDegrees(): KeyScaleDegree[] {
      switch(this.order.name) {
        case 'function':
          return this.scaleInKey.degreesByFunction(this.isFlats)
        default:
          return this.scaleInKey.degrees(this.isFlats)
      }
    },
    suggestions(): PreciseChordWeighting[] {
      return suggestNextChord(this.chordProgression, this.selectedIndex)
    }
  },
  methods: {
    addChord(degree: number, variantType: VariantType<KeyScaleChord>, inversion: number, octave: number) {
      setChord(this.$route, this.$router, {
        degree,
        variantType,
        inversion,
        octave,
        index: this.selectedIndex
      } as SetChordParameters)
    },
    suggestionsForDegree(degree: number) {
      return this.suggestions.filter(s => s.toDegree === degree)
    },
    cloneChord(degree: KeyScaleDegree): SetChordParameters {
      const chordOptionVm = (this.$refs[degree.degree] as Vue[])[0] as unknown as ChordOptionVm
      return chordOptionVm.getChordParameters();
    },
    getChordParams(index: number): SetChordParameters {
      return this.cloneChord(this.orderedDegrees[index])
    }
  }
})
